import { useCallback } from "react";
import { useQuery } from "@apollo/client";

import { GET_WORK_SESSIONS } from "graphql/query/attendance-gql";


const useAttendanceSession = (eeId) => {
    const { data, loading, error, observable } = useQuery(GET_WORK_SESSIONS, {
        variables: {
            where: {
                column: "EE_ID",
                operator: "EQ",
                value: eeId
            },
            orderBy: [
                {
                    column: "CHECK_IN_AT",
                    order: "DESC"
                }
            ],
            first: 1
        },
        skip: !eeId,
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true,
        context: {
            queryDeduplication: false
        }
    });

    const refresh = useCallback(async () => {
        if (!eeId) {
            throw new Error("Attendance exhibition is unavailable");
        }

        // Replacing the observer prevents an older response from restoring stale status.
        await observable.reobserve();
        const latest = observable.getCurrentResult();

        if (
            latest.loading || latest.error || latest.errors?.length || latest.partial ||
            !Array.isArray(latest.data?.workSessionsCursor?.edges)
        ) {
            throw latest.error || new Error("Current attendance status is unavailable");
        }

        const currentSession = latest.data.workSessionsCursor.edges[0]?.node || null;

        return {
            currentSession,
            isCheckedIn: Boolean(currentSession?.check_in_at && !currentSession?.check_out_at)
        };
    }, [ eeId, observable ]);

    const currentSession = data?.workSessionsCursor?.edges?.[0]?.node || null;

    return {
        currentSession,
        isCheckedIn: Boolean(currentSession?.check_in_at && !currentSession?.check_out_at),
        loading: loading && !data,
        error,
        refresh
    };
};

export default useAttendanceSession;
